import { FileTypeEnum } from 'app/graphql/generated/graphqlApolloTypes';

import { JobStatus } from 'app/models';

import { getLocale } from 'utils/helpers/getLocale';
import { formatMessage } from 'utils/messages/utils';

export const sortByStartTime = (items) => {
  return items.sort((a, b) => b.startDate - a.startDate);
};

export const sortByEndTime = (items) => {
  return items.sort((a, b) => b.endDate - a.endDate);
};

export const sortJobItems = (jobItems) => {
  const activeJobs = sortByStartTime(jobItems.filter((job) => job.isActive || job.status === JobStatus.PENDING));
  const failedJobs = sortByEndTime(jobItems.filter((job) => job.status === JobStatus.FAILED));
  const completedJobs = sortByEndTime(jobItems.filter((job) => job.status === JobStatus.COMPLETED));
  return [...activeJobs, ...failedJobs, ...completedJobs];
};

export const getJobItemDetail = (item) => {
  const metaData = JSON.parse(item.metadata || null);

  return {
    startTime: new Date(item.startDate * 1000),
    endTime: item.endDate ? new Date(item.endDate * 1000) : null,
    isInProgress: item.status === JobStatus.IN_PROGRESS || item.status === JobStatus.PENDING,
    metaData,
    actorFullName: metaData ? metaData.actorFirstName?.concat(' ', metaData.actorLastName) : ''
  };
};

export const getFormattedTime = (time: Date) => {
  if (!time) return '';
  const now = new Date();

  // Check if it's within today
  const todayStart = new Date(now.setHours(0, 0, 0, 0)); // Start of today (midnight)

  const formattedDate = time.toLocaleString(getLocale(), {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });

  const formattedTime = time.toLocaleString(getLocale(), {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
  });

  if (time >= todayStart) {
    return formattedTime;
  }

  return `${formattedDate} ${formattedTime}`;
};

export const FileTypeMap = {
  [FileTypeEnum.Activity]: formatMessage('ACTIVITY'),
  [FileTypeEnum.TerritoryRule]: formatMessage('TERRITORY'),
  [FileTypeEnum.CustomHierarchy]: formatMessage('CUSTOM_HIERARCHY'),
  [FileTypeEnum.CustomerAccountHierarchy]: formatMessage('CUSTOMER_ACCOUNT_HIERARCHY'),
  [FileTypeEnum.Location]: formatMessage('PIN_SET'),
  [FileTypeEnum.Participant]: formatMessage('USER'),
  [FileTypeEnum.AccountRedirect]: formatMessage('ACCOUNT_ALIGNMENT'),
  [FileTypeEnum.SellerAssignment]: formatMessage('SELLER_ASSIGNMENT'),
  [FileTypeEnum.TerritoryQuota]: formatMessage('TERRITORY_QUOTA')
};

export const checkWithinLast7Days = (time: Date) => {
  const today = new Date();
  const sevenDaysAgo = new Date(today);
  sevenDaysAgo.setDate(today.getDate() - 7);
  return time >= sevenDaysAgo;
};
